import { render, staticRenderFns } from "./NaturalLanguageQueryView.vue?vue&type=template&id=69f12b75&scoped=true"
import script from "./NaturalLanguageQueryView.vue?vue&type=script&lang=js"
export * from "./NaturalLanguageQueryView.vue?vue&type=script&lang=js"
import style0 from "./NaturalLanguageQueryView.vue?vue&type=style&index=0&id=69f12b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f12b75",
  null
  
)

export default component.exports